import React from 'react';
import { ConfigProvider, DatePicker } from 'antd';
import { Provider } from 'react-redux';
import { Router } from './Router';
import store from './store';
import useLanguage from './hooks/useLanguage';
import viVN from 'antd/locale/vi_VN';
import enUS from 'antd/locale/en_US';
import 'dayjs/locale/vi';
import 'dayjs/locale/en';
import i18n from 'i18next';


function App() {
  useLanguage();
  const currentLanguage = i18n.language;

  return (
    <div className="ctn">
      <Provider store={store}>
        <ConfigProvider
          locale={currentLanguage == 'vi' ? viVN : enUS}
          theme={{
            token: {
              colorPrimary: '#2B48AC',
            },
          }}
        >
          <Router />
        </ConfigProvider>
      </Provider>
    </div>
  );
}

export default App;
